import shop from './apiList/shop'
import login from './apiList/login'
import owner from './apiList/owner'
import orderLog from './apiList/orderLog'
import orderDetail from './apiList/orderDetail'
import shopCar from './apiList/shopCar'
import orderShop from './apiList/orderShop'
export default {
  shop,
  login,
  owner,
  orderLog,
  orderDetail,
  shopCar,
  orderShop
}
